module.exports = __webpack_public_path__ + "img/q3.cf91bfee.svg";